//Core
import React from "react"
import Helmet from "react-helmet"

//Components
import Header from "../components/Header/header"
import Devices from "../components/Devices"
import HowToSetUp from "../components/HowToSetUp"
import HowToPay from "../components/HowToPay"
import Advantages from "../components/Advantages"
import FAQ from "../components/FAQ"
import Order from "../components/Order"
import Callback from "../components/Callback"

//Styles
import "../style/index.scss"

const Home = () => (
  <>
    <Helmet>
      <title>
        Apple Pay платежи в ТАСКОМБАНК | Интеграция Apple Pay с Visa и
        Mastercard
      </title>
      <meta
        name="description"
        content="Настраивайте Apple Pay с картами ТАСКОМБАНК и оплачивайте счета бесконтактно. Теперь вы можете добавить карты Visa и Mastercard от ТАСКОМБАНК в Apple Pay и производить оплату за повседневные операции одним движением руки. Иcпользуйте все преимущества Apple pay уже сейчас!"
      />
      <meta
        property="og:title"
        content=" Apple Pay платежи в ТАСКОМБАНК | Интеграция Apple Pay с Visa и Mastercard"
      />
      <meta
        property="og:description"
        content="Настраивайте Apple Pay с картами ТАСКОМБАНК и оплачивайте счета бесконтактно. Теперь вы можете добавить карты Visa и Mastercard от ТАСКОМБАНК в Apple Pay и производить оплату за повседневные операции одним движением руки. Иcпользуйте все преимущества Apple pay уже сейчас!"
      />
      <meta
        property="og:image"
        content="Настраивайте Apple Pay с картами ТАСКОМБАНК и оплачивайте счета бесконтактно. Теперь вы можете добавить карты Visa и Mastercard от ТАСКОМБАНК в Apple Pay и производить оплату за повседневные операции одним движением руки. Иcпользуйте все преимущества Apple pay уже сейчас!"
      />
      <link rel="canonical" href="https://tascombank.ua/apple_pay" />
    </Helmet>
    <Header />
    <Devices />
    <HowToSetUp />
    <HowToPay />
    <Advantages />
    <FAQ />
    <Order />
    <Callback />
  </>
)

export default Home
